import React, { useEffect, useRef, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import styled from 'styled-components';
import * as api from '../services/api';

const Wrapper = styled.div`
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f5f5f5;
  padding: 24px;
`;

const Card = styled.div`
  width: 100%;
  max-width: 440px;
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  padding: 40px;
  text-align: center;
`;

const Title = styled.h1`
  font-size: 24px;
  font-weight: 600;
  color: #1a1a1a;
  margin: 0 0 16px;
`;

const Message = styled.p`
  font-size: 16px;
  color: #374151;
  margin: 0 0 24px;
  line-height: 1.5;
`;

const ErrorText = styled.p`
  color: #dc2626;
  font-size: 14px;
  margin: 0 0 16px;
`;

const StyledLink = styled(Link)`
  display: inline-block;
  font-size: 14px;
  color: #2563eb;
  text-decoration: none;
  &:hover {
    text-decoration: underline;
  }
`;

const VerifyEmail: React.FC = () => {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token') || '';
  const [status, setStatus] = useState<'loading' | 'success' | 'error'>('loading');
  const [message, setMessage] = useState('');
  const hasVerifiedRef = useRef(false);

  useEffect(() => {
    if (!token) {
      setStatus('error');
      setMessage('Missing verification token.');
      return;
    }
    if (hasVerifiedRef.current) return;
    hasVerifiedRef.current = true;
    api
      .verifyEmail(token)
      .then((res) => {
        if (res?.success) {
          setStatus('success');
          setMessage(res?.message || 'Email verified. You can now sign in.');
        } else {
          setStatus('error');
          setMessage(res?.message || 'Invalid or expired verification link.');
        }
      })
      .catch((err: any) => {
        setStatus('error');
        setMessage(err?.data?.message || err?.message || 'Verification failed.');
      });
  }, [token]);

  return (
    <Wrapper>
      <Card>
        <Title>Verify your email</Title>
        {status === 'loading' && <Message>Verifying…</Message>}
        {status === 'success' && (
          <>
            <Message>{message}</Message>
            <StyledLink to="/login">Sign in</StyledLink>
          </>
        )}
        {status === 'error' && (
          <>
            <ErrorText>{message}</ErrorText>
            <StyledLink to="/signup">Back to sign up</StyledLink>
          </>
        )}
      </Card>
    </Wrapper>
  );
};

export default VerifyEmail;
